export default __webpack_public_path__ + "57e7ce5ba9935428e22d8977d6a9168e.svg";